// extracted by mini-css-extract-plugin
export default {"smallerImg":"DesignComment_smallerImg__kstD4"};